function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M39.4945 36.3848C42.2968 36.3848 44.5685 34.1131 44.5685 31.3108C44.5685 28.5082 42.2968 26.2365 39.4945 26.2365V36.3848Z",
  fill: "#E6123D"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M40.3013 35.5014V27.1196C42.27 27.498 43.7621 29.2334 43.7621 31.3107C43.7621 33.388 42.27 35.1234 40.3013 35.5014ZM40.707 11.4181C37.6968 8.40795 33.71 6.74982 29.4811 6.74982C25.2522 6.74982 21.2653 8.40795 18.2548 11.4181C17.1104 12.5629 16.1613 13.8485 15.4245 15.2349C14.951 16.5289 16.4796 16.8448 16.8505 15.9845C19.2477 11.4559 24.0102 8.3634 29.4811 8.3634C37.3556 8.3634 43.7621 14.7698 43.7621 22.6444V27.2705C42.6895 26.1382 41.1738 25.4298 39.4947 25.4298C39.0489 25.4298 38.6877 25.7909 38.6877 26.2364V36.3847C38.6877 36.8305 39.0489 37.1916 39.4947 37.1916C42.707 37.1916 45.3247 34.602 45.3733 31.4008C45.3736 31.391 45.3746 28.472 45.3753 22.6444C45.3753 18.4155 43.7175 14.4286 40.707 11.4181Z",
  fill: "#424750"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M43.9048 36.3035C43.7002 36.3035 43.4994 36.3869 43.3546 36.5313C43.2099 36.6761 43.1268 36.8769 43.1268 37.0825C43.1268 37.2863 43.2099 37.4868 43.3546 37.6326C43.4994 37.7771 43.7002 37.8597 43.9048 37.8597C44.1093 37.8597 44.3101 37.7771 44.4549 37.6326C44.5997 37.4868 44.6827 37.287 44.6827 37.0825C44.6827 36.8769 44.5997 36.6761 44.4549 36.5313C44.3101 36.3869 44.1093 36.3035 43.9048 36.3035Z",
  fill: "#424750"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M32.2522 44.0203L33.397 43.777L33.6404 44.9218L32.4956 45.1651L32.2522 44.0203ZM43.463 38.8393C43.0772 38.6166 42.5834 38.7486 42.3607 39.1343C40.795 41.8448 38.3343 43.7091 35.2138 44.563L34.8078 42.6524C34.7149 42.2164 34.2867 41.9383 33.8506 42.0307L31.1277 42.6096C30.6916 42.7024 30.4135 43.1307 30.5063 43.5667L31.0851 46.2897C31.1776 46.7257 31.6059 47.0038 32.0419 46.9113L34.7652 46.3325C38.7184 45.4922 41.8281 43.2822 43.7579 39.9416C43.981 39.5559 43.8487 39.0624 43.463 38.8393Z",
  fill: "#424750"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.8471 37.4615C10.3344 37.4615 9.10831 36.2353 9.10831 34.7226V20.3607C9.10831 18.848 10.3344 17.6219 11.8471 17.6219H31.576C33.0887 17.6219 34.3148 18.848 34.3148 20.3607V38.4132C34.3148 39.3758 33.5345 40.1561 32.572 40.1561C32.0468 40.1561 31.5497 39.9195 31.2189 39.5118L29.5547 37.4615H11.8471ZM11.8471 19.1156C11.1596 19.1156 10.6021 19.6732 10.6021 20.3607V34.7226C10.6021 35.4101 11.1596 35.9677 11.8471 35.9677H30.2662L32.3786 38.5701C32.4258 38.6285 32.4971 38.6623 32.572 38.6623C32.7097 38.6623 32.8211 38.5509 32.8211 38.4132V20.3607C32.8211 19.6732 32.2635 19.1156 31.576 19.1156H11.8471Z",
  fill: "#19BFD3"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.2996 26.7646H31.3213V28.0711L28.6885 34.5808H27.0661L29.6217 28.2385H26.2996V26.7646ZM24.3202 26.6252V28.0545H23.4869V29.3833H21.9425V28.0545H18.2651V26.6252L20.9435 21.4109H22.5878L19.9206 26.6252H21.9425V24.7717H23.4869V26.6252H24.3202ZM12.2347 29.3833V28.2331L14.8898 25.4865C15.39 24.9617 15.7788 24.448 15.7788 23.9232C15.7788 23.2978 15.3565 22.907 14.7676 22.907C14.1679 22.907 13.7234 23.2644 13.4679 23.8226L12.179 23.0633C12.6792 21.9468 13.69 21.4109 14.7457 21.4109C16.0788 21.4109 17.312 22.3039 17.312 23.8672C17.312 24.8162 16.7676 25.6316 16.0342 26.3684L14.5121 27.8983H17.4342V29.3833H12.2347Z",
  fill: "#424750"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M28.0015 21.6874L21.0642 34.5809H21.7365L28.6691 21.6874H28.0015Z",
  fill: "#E6123D"
});

function SvgSupport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 54,
    viewBox: "0 0 55 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.85e4542c.svg";
export { ForwardRef as ReactComponent };